const getFormId = ({ formEditor }) => formEditor.form.id;
const getForm = ({ formEditor }) => formEditor.form;
const getIsSaving = ({ formEditor }) => formEditor.isSaving;

export default {
  getFormId,
  getForm,
  getIsSaving
};
